import { render, staticRenderFns } from "./FunctionPopularityFilters.vue?vue&type=template&id=d4d160b2"
import script from "./FunctionPopularityFilters.vue?vue&type=script&lang=js"
export * from "./FunctionPopularityFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports